import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginCallbackComponent } from './login-callback/login-callback.component';
import { LoginFooterComponent } from './login/login-footer/login-footer.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ChangePasswordService } from './services/change-password.service';
import { UniversalLoginService } from './services/universal-login.service';
import { EmailVerificationDialogComponent } from './email-verification-dialog/email-verification-dialog.component';
import { EmailVerificationDialogService } from './email-verification-dialog/email-verification-dialog.service';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        /*LanguageModule,
        LocalizationModule,*/
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        NgOptimizedImage,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
    ],
    declarations: [
        LoginComponent,
        LoginFooterComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        LoginCallbackComponent,
        EmailVerificationDialogComponent,
    ],
    providers: [
        //  TranslationService,
        //  LoginService,
        //  User
        ChangePasswordService,
        UniversalLoginService,
        EmailVerificationDialogService,
    ],
    exports: [
        LoginComponent,
    ],
})
export class LoginModule {
}

